import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import SkewedButton from '../common/SkewedButton';
import SkewedInput from '../common/SkewedInput';
import SkewedCard from '../common/SkewedCard';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Failed to sign in. Please check your credentials.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light">
      <SkewedCard className="w-full max-w-md" padding="p-8">
        <h2 className="text-2xl font-bold text-center mb-6 text-dark">Artist Login</h2>

        {error && (
          <SkewedCard borderColor="red" backgroundColor="#fee" padding="p-4" className="mb-4">
            <span className="text-red-700">{error}</span>
          </SkewedCard>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 text-sm font-medium mb-2">
              Email
            </label>
            <SkewedInput
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              enableRandomSkew={false}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block text-gray-700 text-sm font-medium mb-2">
              Password
            </label>
            <SkewedInput
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              enableRandomSkew={false}
            />
          </div>

          <SkewedButton
            type="submit"
            disabled={loading}
            variant="primary"
            className="w-full"
          >
            {loading ? 'Logging in...' : 'Login'}
          </SkewedButton>
        </form>
      </SkewedCard>
    </div>
  );
};

export default Login;